export default {
  LOCAL_STORAGE_KEY: 'harbinger-event-queue',
}
